
import { useState } from 'react';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '勉強が嫌いでも大丈夫ですか？',
      answer: 'はい、大丈夫です。勉強のやり方から丁寧に教えますので、勉強が苦手なお子様でも安心してお任せください。まずは小さな成功体験を積み重ねることで、勉強への苦手意識を克服していきます。'
    },
    {
      question: '部活と両立できますか？',
      answer: 'はい、できます。部活動のスケジュールに合わせて授業時間を調整できますので、無理なく両立できます。多くの生徒が部活と勉強を両立しながら、成績アップを実現しています。'
    },
    {
      question: '宿題は多いですか？',
      answer: 'お子様の学力や目標に合わせて適切な量を出します。無理のない範囲で学習習慣が身につく量です。部活や他の習い事との両立も考慮して調整しますので、ご安心ください。'
    },
    {
      question: '定期テスト前はどうなりますか？',
      answer: 'テスト2週間前から集中的に対策を行います。学校別のテスト範囲を分析し、予想問題を使った演習を実施。提出物の進捗も確認し、内申点アップをサポートします。'
    },
    {
      question: '授業の振替はできますか？',
      answer: 'はい、できます。前日までにご連絡いただければ、別の日時に振替可能です。急な体調不良や学校行事にも柔軟に対応いたします。'
    },
    {
      question: '自習室はいつでも使えますか？',
      answer: '開校時間内であればいつでも利用可能です。授業がない日も自習室で勉強でき、わからない問題は講師に質問できます。集中できる環境を提供しています。'
    },
    {
      question: '途中入塾はできますか？',
      answer: 'はい、いつでも入塾できます。お子様の現在の学力を確認し、最適なカリキュラムを組みますので、途中からでも安心してスタートできます。'
    },
    {
      question: '体験授業は本当に無料ですか？',
      answer: 'はい、完全無料です。60分の授業を実際に体験していただけます。お子様に合うかどうか、じっくりご検討ください。無理な勧誘は一切いたしません。'
    },
    {
      question: '保護者への報告はありますか？',
      answer: 'はい、月1回の学習報告書で進捗を共有します。また、定期的に保護者面談も実施し、お子様の学習状況や今後の方針についてご相談いただけます。'
    },
    {
      question: '英検や漢検の対策もできますか？',
      answer: 'はい、対応可能です。英検・漢検の対策も通常授業の中で行えます。検定取得は内申点アップにもつながりますので、積極的にサポートしています。'
    },
    {
      question: '兄弟割引はありますか？',
      answer: 'はい、ございます。ご兄弟で通塾される場合、2人目以降の授業料が10%割引になります。詳しくはお問い合わせください。'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            よくある質問
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の学習塾について、よくいただく質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-blue-50 transition-colors cursor-pointer"
              >
                <h4 className="text-base md:text-lg font-bold text-gray-800 pr-4">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-down-s-line text-2xl text-blue-600 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 pt-2">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 rounded-xl p-6 md:p-8 text-center border border-blue-100">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">
            その他のご質問はお気軽に
          </h3>
          <p className="text-sm md:text-base text-gray-700 mb-4">
            <strong>中学生の塾</strong>として、<strong>定期テスト対策</strong>や<strong>学習習慣づけ</strong>について、<br className="hidden md:block" />
            どんな小さなことでもお答えします。
          </p>
          <p className="text-sm text-gray-600">
            お電話またはLINEでお気軽にお問い合わせください
          </p>
        </div>
      </div>
    </section>
  );
}
